export const Definitions = {
  FIRST_NAME: 'first_name',
  LAST_NAME: 'last_name',
  GENDER: 'gender',
  DATE_OF_BIRTH: 'date_of_birth',
  CELL_PHONE_NUMBER: 'cell_phone_number',
  HEIGHT: 'height',
  WEIGHT: 'weight',
  RACE: 'race',
  ETHNICITY: 'ethnicity',
  PREFERRED_LANGUGAGE: 'preferred_language',
  ALLERGIES: 'allergies',
  MEDICATIONS: 'medications'
};